<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list @form="openForm" @clear="$refs.form.clear()" />
        <form-manager
          ref="form"
          :dialog="dialog"
          :parent-category="parentCategoryId"
          @close="dialog = false"
          @reset="parentCategoryId = ''"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FormManager from './FormManager'
import List from './List'

export default {
  name: 'Categories',
  components: {
    FormManager,
    List,
  },
  data() {
    return {
      dialog: false,
      parentCategoryId: '',
    }
  },
  mounted() {
    this.$store.dispatch('categories/resetState')
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      fetchCategories: 'categories/fetchList',
      getOne: 'categories/fetchOne',
      setStatus: 'events/setStatus',
    }),
    openForm(parentCategoryId) {
      this.parentCategoryId = parentCategoryId
      this.dialog = true
    },
    async initData() {
      // this.resetPagitations()
      await Promise.all([
        this.fetchCategories({ only: 1, limit: 0, children: true }),
      ])
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
  },
}
</script>
